import { ShieldCheck, Gauge, ThumbsUp, MessageCircle, Phone, Mail, MapPin, Globe } from "lucide-react";
import { WA_DEFAULT, PHONE_DISPLAY, EMAIL, ADDRESS, useSectionNav } from "./shared";

const VALUES = [
  { icon: ShieldCheck, label: "Secure" },
  { icon: Gauge, label: "Fast" },
  { icon: ThumbsUp, label: "Reliable" },
];

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Upgrades", href: "#upgrades" },
  { label: "Security", href: "#security" },
  { label: "Process", href: "#process" },
  { label: "Estimate", href: "#calculator" },
  { label: "Refurbs & Print", href: "#extras" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  const goToSection = useSectionNav();
  return (
  <footer data-testid="footer" className="relative bg-navy/60 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-4">
          <img
            src="/assets/logo.png"
            alt="AFZ Tech Solutions logo"
            className="h-16 w-16 object-contain drop-shadow-[0_0_16px_rgba(170,255,0,0.45)]"
          />
          <div>
            <p className="font-display text-2xl font-bold uppercase text-white leading-none">
              AFZ <span className="text-brand-lime">Tech Solutions</span>
            </p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-1.5">Repair · Support · Solve</p>
          </div>
        </div>
        <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
          Your trusted partner for all your computer needs. Kembangan, Singapore.
        </p>
        <div className="mt-6 flex gap-6">
          {VALUES.map((v) => (
            <div key={v.label} className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 rounded-full border-2 border-brand-cyan/50 bg-brand-cyan/10 flex items-center justify-center text-brand-cyan">
                <v.icon className="w-4 h-4" />
              </div>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{v.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-display text-lg font-bold uppercase text-white tracking-wide">Explore</h3>
        <nav className="mt-5 flex flex-col gap-3">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`footer-link-${n.label.toLowerCase()}`}
              onClick={() => goToSection(n.href)}
              className="text-left text-sm text-slate-400 hover:text-brand-lime transition-colors w-fit"
            >
              {n.label}
            </button>
          ))}
        </nav>
      </div>

      <div>
        <h3 className="font-display text-lg font-bold uppercase text-white tracking-wide">Contact</h3>
        <div className="mt-5 space-y-3 text-sm text-slate-400">
          <a data-testid="footer-whatsapp-link" href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-lime transition-colors">
            <MessageCircle className="w-4 h-4 text-brand-lime" /> WhatsApp {PHONE_DISPLAY}
          </a>
          <a data-testid="footer-phone-link" href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} className="flex items-center gap-3 hover:text-brand-lime transition-colors">
            <Phone className="w-4 h-4 text-brand-lime" /> {PHONE_DISPLAY}
          </a>
          <a data-testid="footer-email-link" href={`mailto:${EMAIL}`} className="flex items-center gap-3 hover:text-brand-lime transition-colors">
            <Mail className="w-4 h-4 text-brand-lime" /> {EMAIL}
          </a>
          <p className="flex items-center gap-3">
            <MapPin className="w-4 h-4 text-brand-lime shrink-0" /> {ADDRESS}
          </p>
          <a data-testid="footer-website-link" href="https://afztechsolutions.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-brand-lime transition-colors">
            <Globe className="w-4 h-4 text-brand-lime" /> afztechsolutions.com
          </a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          © 2026 AFZ Tech Solution Singapore · afztechsolutions.com
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-600">
          Secure · Fast · Reliable
        </p>
      </div>
    </div>
  </footer>
  );
};
